import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Image, type TImageProps } from '@/src/elements/image'
import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { Typography, type TTypographyProps } from '@/src/elements/text/Typography'

export type TCommunityThumbnailProps = {
  imageTestID?: string
  title?: string
  imgSource?: TImageProps['source']
  isLoading?: boolean
  bold?: boolean
  showImage?: boolean
  centered?: boolean
  wrapperClassName?: string
  ellipsis?: boolean
  subtitle?: ReactNode[] | ReactNode
  subtitleProps?: TTypographyProps
  titleProps?: TTypographyProps
}

export const CommunityThumbnail = ({
  title,
  imgSource,
  imageTestID,
  isLoading,
  centered,
  showImage,
  wrapperClassName,
  ellipsis = true,
  subtitle,
  bold,
  subtitleProps,
  titleProps,
}: TCommunityThumbnailProps): ReactNode => (
  <View className={clsx('flex w-full flex-row gap-3', centered ? 'items-center' : '', wrapperClassName)}>
    {!!showImage &&
      (!imgSource && isLoading ? (
        <Placeholder className="h-12 w-12 rounded-xl" />
      ) : (
        <View className="h-12 w-12 rounded-xl">
          <Image source={imgSource} className="w-full rounded-lg" contentFit="cover" testID={imageTestID} />
        </View>
      ))}
    <View className="flex flex-1 flex-col justify-evenly">
      <View>
        {isLoading && !title ? (
          <PlaceholderLine className="max-w-96 animate-pulse" />
        ) : (
          <Typography
            colors="default"
            size="sm"
            bold={bold}
            {...titleProps}
            className={clsx(!ellipsis ? '' : 'line-clamp-2 grow overflow-hidden', titleProps?.className)}
          >
            {title}
          </Typography>
        )}
      </View>
      {subtitle && (
        <Typography
          size="xs"
          contrast="low"
          className="overflow-hidden text-ellipsis whitespace-nowrap"
          {...subtitleProps}
        >
          {subtitle}
        </Typography>
      )}
    </View>
  </View>
)
